import { Link } from "react-router-dom";
import { Lock, Mail, Phone, Star } from "lucide-react";
import { LogoMark } from "./Logo";
import { REGIONS } from "@/lib/services";

export default function Footer() {
    return (
        <footer className="border-t border-gold/20 bg-ink-2">
            <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-8 md:grid-cols-3 lg:px-16">
                <div>
                    <span className="inline-flex items-center gap-3">
                        <LogoMark />
                        <span className="font-display text-lg font-extrabold tracking-tight text-slate-50">
                            B&amp;B <span className="text-gold">Painting</span>
                        </span>
                    </span>
                    <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
                        Professional painting services for homes, businesses and construction
                        projects across the Greater Toronto Area.
                    </p>
                    <a
                        href="https://share.google/ne3cGjXAE31IWlowE"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-google-link"
                        className="mt-5 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.15em] text-gold hover:text-gold-light"
                    >
                        <Star size={13} fill="currentColor" strokeWidth={0} /> 5.0 on Google · 10 reviews
                    </a>
                </div>
                <div>
                    <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-gold">Explore</h4>
                    <ul className="mt-5 space-y-3 text-sm">
                        {[
                            ["/services", "Services", "footer-link-services"],
                            ["/portfolio", "Project Portfolio", "footer-link-portfolio"],
                            ["/builders", "Builders & Contractors", "footer-link-builders"],
                            ["/about", "About Us", "footer-link-about"],
                            ["/contact", "Contact & Free Quote", "footer-link-contact"],
                        ].map(([to, label, id]) => (
                            <li key={to}>
                                <Link to={to} data-testid={id} className="text-slate-300 transition-colors hover:text-gold">
                                    {label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-gold">Contact</h4>
                    <ul className="mt-5 space-y-4 text-sm">
                        <li>
                            <a href="tel:+16475104012" data-testid="footer-phone-link" className="flex items-center gap-3 text-slate-200 transition-colors hover:text-gold">
                                <Phone size={15} className="text-gold" /> 647 510 4012
                            </a>
                        </li>
                        <li>
                            <a href="mailto:Bnbpaintinginc@gmail.com" data-testid="footer-email-link" className="flex items-center gap-3 break-all text-slate-200 transition-colors hover:text-gold">
                                <Mail size={15} className="text-gold" /> Bnbpaintinginc@gmail.com
                            </a>
                        </li>
                    </ul>
                    <p className="mt-6 text-xs leading-relaxed text-slate-500">
                        Serving: {REGIONS.join(" · ")} and surrounding Ontario communities.
                    </p>
                    <Link
                        to="/admin"
                        data-testid="footer-admin-link"
                        className="mt-5 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-600 transition-colors hover:text-gold"
                    >
                        <Lock size={11} /> Owner Login
                    </Link>
                </div>
            </div>
            <div className="border-t border-gold/15 px-4 py-6 text-center font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
                © {new Date().getFullYear()} B&amp;B Painting and Renovation · Ontario, Canada
            </div>
        </footer>
    );
}